import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const ActivityTimeframeWrapper = styled('div', { label: 'ActivityTimeframeWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: var(--font-family-primary);
`;

export const ActivityTimeframeDescription = styled('p', { label: 'ActivityTimeframeDescription' })`
    margin: 0;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const ActivityTimeframeSection = styled('section', { label: 'ActivityTimeframeSection' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const ActivityTimeframeSectionTitle = styled('h3', { label: 'ActivityTimeframeSectionTitle' })`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const ActivityTimeframeFormFields = styled('div', { label: 'ActivityTimeframeFormFields' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ActivityTimeframeFormRow = styled('div', { label: 'ActivityTimeframeFormRow' })`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }
`;

export const ActivityTimeframeFormLabel = styled('label', { label: 'ActivityTimeframeFormLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    flex: 1;
`;

export const ActivityTimeframeFormValue = styled('div', { label: 'ActivityTimeframeFormValue' })`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 280px;
`;

export const ActivityTimeframeUnitSuffix = styled('span', { label: 'ActivityTimeframeUnitSuffix' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
    flex-shrink: 0;
`;

export const ActivityTimeframeActions = styled('div', { label: 'ActivityTimeframeActions' })`
    display: flex;
    justify-content: flex-start;
    margin-top: 24px;
`;
